import { MantineThemeOverride, createTheme } from '@mantine/core';

import { ActionIconDefaults, ButtonDefaults, CloseButtonDefaults } from '../Buttons';
import { DonutChartDefaults } from '../Charts';
import { AutocompleteInputDefaults, ComboboxDefaults } from '../Combobox';
import {
  AccordionDefaults,
  AvatarDefaults,
  BadgeDefaults,
  CardDefaults,
  ImageDefaults,
  IndicatorDefaults,
} from '../DataDisplay';
import { DatePickerInputDefaults, TimeInputDefaults } from '../Dates';
import {
  AlertDefaults,
  LoaderDefaultProps,
  NotificationDefaults,
  NotificationsDefaults,
  ProgressDefaults,
  ProgressSectionDefaults,
  RingProgressDefaults,
  SkeletonDefaults,
} from '../Feedback';
import {
  CheckboxDefaults,
  CheckboxIndicatorDefaults,
  InputDefaults,
  InputWrapperDefaults,
  MultiSelectDefaults,
  NumberInputDefaults,
  PassowrdInputDefaults,
  PillDefaults,
  PillsInputDefaults,
  PinInputDefaults,
  RadioDefaults,
  RadioIndicatorDefaults,
  SegmentedControlDefaults,
  SelectDefaults,
  SwitchDefaults,
  TextInputDefaults,
  TextareaDefaults,
} from '../Inputs';
import { ContainerDefaults } from '../Layout';
import { DividerDefaults } from '../Miscellaneous';
import {
  AnchorDefaults,
  BreadcrumbsDefaults,
  NavLinkDefaults,
  PaginationDefaults,
  TabDefaults,
} from '../Navigation';
import { StepperDefaults } from '../Navigation/Stepper/Stepper.defaults';
import {
  DrawerDefaultProps,
  MenuDefaults,
  MenuItemDefaults,
  ModalDefaults,
  PopoverDefaults,
  TooltipDefaults,
} from '../Overlays';
import { SpotlightDefaults } from '../Spotlight/Spotlight';
import { TableDefaults, defaultTextProps, defaultTitleProps } from '../Typography';

const themeComponents: MantineThemeOverride = createTheme({
  components: {
    Accordion: AccordionDefaults,
    ActionIcon: ActionIconDefaults,
    Anchor: AnchorDefaults,
    Alert: AlertDefaults,
    Autocomplete: AutocompleteInputDefaults,
    Avatar: AvatarDefaults,
    Badge: BadgeDefaults,
    Breadcrumbs: BreadcrumbsDefaults,
    Button: ButtonDefaults,
    Card: CardDefaults,
    CloseButton: CloseButtonDefaults,
    Combobox: ComboboxDefaults,
    DatePickerInput: DatePickerInputDefaults,
    Divider: DividerDefaults,
    DonutChart: DonutChartDefaults,
    Drawer: { defaultProps: DrawerDefaultProps },
    Checkbox: CheckboxDefaults,
    CheckboxIndicator: CheckboxIndicatorDefaults,
    Container: ContainerDefaults,
    Image: ImageDefaults,
    Indicator: IndicatorDefaults,
    Input: InputDefaults,
    InputWrapper: InputWrapperDefaults,
    Loader: { defaultProps: () => LoaderDefaultProps() },
    Menu: MenuDefaults,
    MenuItem: MenuItemDefaults,
    Modal: ModalDefaults,
    MultiSelect: MultiSelectDefaults,
    NavLink: NavLinkDefaults,
    Notification: NotificationDefaults,
    Notifications: NotificationsDefaults,
    NumberInput: NumberInputDefaults,
    Popover: PopoverDefaults,
    Pagination: PaginationDefaults,
    PasswordInput: PassowrdInputDefaults,
    PinInput: PinInputDefaults,
    Pill: PillDefaults,
    PillsInput: PillsInputDefaults,
    Progress: ProgressDefaults,
    ProgressSection: ProgressSectionDefaults,
    Radio: RadioDefaults,
    RadioIndicator: RadioIndicatorDefaults,
    RingProgress: RingProgressDefaults,
    Select: SelectDefaults,
    SegmentedControl: SegmentedControlDefaults,
    Skeleton: SkeletonDefaults,
    Spotlight: SpotlightDefaults,
    Stepper: StepperDefaults,
    Switch: SwitchDefaults,
    Tooltip: TooltipDefaults,
    Table: TableDefaults,
    Text: defaultTextProps,
    Textarea: TextareaDefaults,
    TextInput: TextInputDefaults,
    TimeInput: TimeInputDefaults,
    Title: defaultTitleProps,
    Tabs: TabDefaults,
  },
});
export { themeComponents };
